import { useGlobalControls, useTidalSandbox } from '@workwave-tidal/sandbox-utils'
import { Children, type ReactNode } from 'react'
import { ResizablePanel } from './ResizablePanel.js'
import { Tools } from './Tools.js'
import type { ToolsProps } from './types.js'

export function TidalSandboxGlobalToolbar(props: ToolsProps) {
  const { children, placement } = props

  const { globalControlsDisabled, globalControlsConfig } = useTidalSandbox()
  const config = globalControlsConfig[placement]

  const { controls } = useGlobalControls()
  const controlsToPlace = controls[placement] as ReactNode

  const tabsCount = Children.count(children) + Children.count(controlsToPlace)

  if (globalControlsDisabled || tabsCount === 0 || config?.hide) {
    return null
  }

  return (
    <ResizablePanel
      disabled={config?.disableResize}
      initialSize={config?.initialSize}
      minSize={config?.minSize}
      placement={placement}
    >
      <Tools placement={placement}>
        {children as any}
        {controlsToPlace}
      </Tools>
    </ResizablePanel>
  )
}
